import { render, staticRenderFns } from "./mainText.vue?vue&type=template&id=6d6f6144&scoped=true&"
import script from "./mainText.vue?vue&type=script&lang=js&"
export * from "./mainText.vue?vue&type=script&lang=js&"
import style0 from "./mainText.vue?vue&type=style&index=0&id=6d6f6144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f6144",
  null
  
)

export default component.exports